module.exports = __webpack_public_path__ + "img/profile-avatar-2.f6c7339a.png";